import { API, authClient } from "../index";

export const getSets = () => {
  return authClient().get(`${API}/set`);
};
